export default __webpack_public_path__ + "static/media/awesomemuslims.db2277bf.PNG";